
<template>
  <!--api列表-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="api_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'api',
  data () {
    return {
      searchList: [
        { props: ['title'], placeholder: 'api名称', options: [], inputType: 'input' },
        { props: ['route'], placeholder: '路由名称', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', handle: '', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '修改', handle: (row) => this.$refs.table.toEdit(row), key: 'edit' },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: '名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '路由', dataIndex: 'route', align: 'left', width: '' },
        { title: '请求方法', dataIndex: 'method', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: '',
        route: ''
      },
      listApi: {
        url: '/apis',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addApi',
        title: '修改api'
      },
      deleteParam: {
        url: '/apis/delete',
        param: {pk_key: 'api_id', pk_val: ''},
        title: 'api',
        key: 'title'
      }
    };
  },
  mounted () {
  },
  methods: {
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
